import {
    CHANGE_ENTITY_STACK_TAB,
    TOGGLE_ENTITY_STACK,
    OPEN_ENTITY_STACK,
    WS_CHANGE_ENTITY_STACK_TAB,
    ENTITY_STACK_ADD_NOTIFICATION,
    ENTITY_STACK_REMOVE_NOTIFICATION,
} from './constants'

export const changeEntityStackTab = (activeTab) => ({ type: CHANGE_ENTITY_STACK_TAB, data: { activeTab } })
export const swChangeEntityStackTab = (activeTab) => ({ type: WS_CHANGE_ENTITY_STACK_TAB, data: { activeTab } })

export const toggleEntityStack = () => ({ type: TOGGLE_ENTITY_STACK })
export const openEntityStack = () => ({ type: OPEN_ENTITY_STACK })

export const entityStackAddNotification = (tabType) => {
    return {
        type: ENTITY_STACK_ADD_NOTIFICATION,
        data: {
            tabType,
        },
    }
}

export const entityStackRemoveNotification = (tabType) => {
    return {
        type: ENTITY_STACK_REMOVE_NOTIFICATION,
        data: {
            tabType,
        },
    }
}
